<div class="border-b border-gray-200 dark:border-grey">
    <button 
      (click)="isOpen = !isOpen"
      class="w-full flex justify-between items-center p-4 text-left"
      [attr.aria-expanded]="isOpen"
    >
      <ng-content select="[accordionTitle]"></ng-content>
      <ng-icon 
        name="faSolidChevronDown" 
        class="pr-4"
        [class.rotate-180]="isOpen"
      />
    </button>
    <div 
      class="overflow-hidden transition-all duration-200"
      [class.max-h-72]="isOpen"
      [class.p-4]="isOpen"
      [class.pt-0]="isOpen"
      [class.max-h-0]="!isOpen"
      [class.overflow-y-auto]="isOpen"
    >
      <ng-content select="[accordionContent]"></ng-content>
    </div>
  </div>